import { render } from "./RecipientDeathSectionDetailsEMROATS.vue?vue&type=template&id=5d3440a3&scoped=true"
import script from "./RecipientDeathSectionDetailsEMROATS.vue?vue&type=script&lang=js"
export * from "./RecipientDeathSectionDetailsEMROATS.vue?vue&type=script&lang=js"

import "./RecipientDeathSectionDetailsEMROATS.vue?vue&type=style&index=0&id=5d3440a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3440a3"],['__file',"src/components/RecipientDeathSectionDetailsEMROATS.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d3440a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d3440a3', __exports__)) {
    api.reload('5d3440a3', __exports__)
  }
  
  module.hot.accept("./RecipientDeathSectionDetailsEMROATS.vue?vue&type=template&id=5d3440a3&scoped=true", () => {
    api.rerender('5d3440a3', render)
  })

}


export default __exports__